// src/routes/paths.ts

/**
 * @fileoverview Общие константы для путей роутинга.
 * Используются для унификации определения роутов и их парсинга.
 */

export const PlayRouteGame = "/play/:game";
export const PlayRouteGameIframe = "/play/:game/iframe/:adapter";
export const PlayerRouteGame = "/player/:game";
export const PlayerRouteGameIframe = ":game/iframe/:adapter";
export const PlayerRouteSingleGameIframe = "/iframe/:adapter";
export const LoginFromGame = "LoginFromGame/:game/:token";

export const GAME_STORE_PATH = "/Store/:game";
export const GAME_DOCS_PATH = "/Docs/:game/:adapter/:doc";
export const CONTINUE_WITH_PI_PATH = "/native/Store/ContinueWithPI/:game/:order/:token";
export const STORE_RETURN_PATH = "/Store/Return/:id";
export const MERCHANT_PAYMENT_COMPLETED_PATH = "/Store/MerchantPaymentCompleted/:token";
export const BANK131_PAYMENT_FORM_PATH = "/Store/Bank131/PaymentForm";

/**
 * Пути, содержащие параметр `:game` и требующие загрузки `gameConfig`.
 * Генерируются автоматически для поддержки чистоты кода.
 * Используются в App.tsx для определения, нужно ли передавать `gameName` в главный запрос.
 */
export const GAME_SPECIFIC_PATHS = [
	PlayRouteGame,
	PlayRouteGameIframe,
	PlayerRouteGame,
	PlayerRouteGameIframe,
	PlayerRouteSingleGameIframe,
	LoginFromGame,
	GAME_STORE_PATH,
	GAME_DOCS_PATH,
	CONTINUE_WITH_PI_PATH
];
